// packages
import { z } from 'zod'
import { User } from './user'
import { privateRouteSchema } from './route'

// enums
export enum exam_library_status {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED'
}

export enum formatted_exam_library_status {
  ACTIVE = 'Ativo',
  DELETED = 'Deletado'
}

export enum exam_library_profile_types {
  PREGNANT = 'PREGNANT',
  LACTATING = 'LACTATING',
  CHILDREN = 'CHILDREN',
  TEMPTING = 'TEMPTING',
  WOMAN = 'WOMAN'
}

export enum formatted_exam_library_profile_types {
  PREGNANT = 'Grávidas',
  LACTATING = 'Lactantes',
  CHILDREN = 'Crianças',
  TEMPTING = 'Homens',
  WOMAN = 'Mulheres'
}

// types
export type ExamLibraryProps = {
  id?: number
  ref?: string
  userId?: number
  title?: string
  description?: string
  paths?: string[]
  status?: exam_library_status
  profileType?: exam_library_profile_types
  createdAt?: Date
  updatedAt?: Date | null
  file?: {
    file?: File
    name?: string
    extension?: string
    base64?: string
    url?: string
  }

  // relationships
  user?: User
}

export type CreateExamLibrarySchema = z.infer<typeof createExamLibrarySchema>
export type UpdateExamLibrarySchema = z.infer<typeof updateExamLibrarySchema>
export type GetExamLibrariesSchema = z.infer<typeof getExamLibrariesSchema>
export type GetExamLibraryByRefSchema = z.infer<typeof getExamLibraryByRefSchema>
export type DeleteExamLibrarySchema = z.infer<typeof deleteExamLibrarySchema>

// schemas
export const createExamLibrarySchema = privateRouteSchema.extend({
  title: z.string({ message: 'Informe o título.' }).min(1, 'Título inválido.').max(100, 'Limite de caracteres: 100.'),
  description: z.string({ message: 'Informe a descrição.' }).min(1, 'Descrição inválida.').max(100, 'Limite de caracteres: 100.'),
  profileType: z.nativeEnum(exam_library_profile_types, { message: 'Tipo de perfil inválido.' }),
  paths: z.array(z.string()).optional()
})
export const updateExamLibrarySchema = createExamLibrarySchema.extend({
  ref: z.string({ message: 'Informe a referência.' }).uuid({ message: 'Referência de exame inválida.' })
})
export const getExamLibrariesSchema = privateRouteSchema
export const getExamLibraryByRefSchema = privateRouteSchema.extend({
  ref: z.string().uuid('Referência de exameinválida.')
})
export const deleteExamLibrarySchema = privateRouteSchema.extend({
  ref: z.string({ message: 'Informe a referência.' }).uuid({ message: 'Referência de exame inválida.' })
})

export class ExamLibrary {
  private props: ExamLibraryProps

  get id() {
    return this.props.id
  }

  get ref() {
    return this.props.ref
  }

  get userId() {
    return this.props.userId
  }

  get title() {
    return this.props.title
  }

  get description() {
    return this.props.description
  }

  get paths() {
    return this.props.paths
  }

  get status() {
    return this.props.status
  }

  get profileType() {
    return this.props.profileType
  }

  get createdAt() {
    return this.props.createdAt
  }

  get updatedAt() {
    return this.props.updatedAt
  }

  get user() {
    return this.props.user
  }

  constructor(props: ExamLibraryProps) {
    this.props = props
  }
}
